(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'react', 'prop-types', 'react-redux', 'reselect', 'react-emotion', 'lodash', './', './NotificationContainer.css'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('react'), require('prop-types'), require('react-redux'), require('reselect'), require('react-emotion'), require('lodash'), require('./'), require('./NotificationContainer.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.react, global.propTypes, global.reactRedux, global.reselect, global.reactEmotion, global.lodash, global._, global.NotificationContainer);
    global.NotificationContainer = mod.exports;
  }
})(this, function (exports, _extends2, _react, _propTypes, _reactRedux, _reselect, _reactEmotion, _lodash, _2, _NotificationContainer) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _lodash2 = _interopRequireDefault(_lodash);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var NotificationContainer = function NotificationContainer(_ref) {
    var notifications = _ref.notifications,
        dismissNotification = _ref.dismissNotification,
        className = _ref.className;
    return _react2.default.createElement(
      'div',
      { className: 'container ' + (0, _reactEmotion.cx)(_NotificationContainer.notificationContainerClass, className) },
      _lodash2.default.map(notifications, function (props, i) {
        return _react2.default.createElement(_2.Notification, (0, _extends3.default)({
          key: i
        }, props, {
          dismissNotification: dismissNotification
        }));
      })
    );
  };

  NotificationContainer.propTypes = {
    notifications: _propTypes2.default.array
  };

  var getVisibleNotifications = (0, _reselect.createSelector)([function (state) {
    return state.notifications;
  }], function (notifications) {
    return notifications.list || [];
  });

  function mapStateToProps(state) {
    return {
      notifications: getVisibleNotifications(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      dismissNotification: function dismissNotification(id) {
        dispatch((0, _2.dismissNotification)(id));
      }
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NotificationContainer);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Notifications/NotificationContainer.js
// module id = 1148
// module chunks = 0